import { render, staticRenderFns } from "./SupervisorSubmitForm.vue?vue&type=template&id=38d9bb35&scoped=true"
import script from "./SupervisorSubmitForm.vue?vue&type=script&lang=js"
export * from "./SupervisorSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./SupervisorSubmitForm.vue?vue&type=style&index=0&id=38d9bb35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9bb35",
  null
  
)

export default component.exports